/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProcedureMedicine from './procedure-medicine';
import ProcedureMedicineDetail from './procedure-medicine-detail';
import ProcedureMedicineUpdate from './procedure-medicine-update';
import ProcedureMedicineDeleteDialog from './procedure-medicine-delete-dialog';

const ProcedureMedicineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProcedureMedicine />} />
    <Route path="new" element={<ProcedureMedicineUpdate />} />
    <Route path=":id">
      <Route index element={<ProcedureMedicineDetail />} />
      <Route path="edit" element={<ProcedureMedicineUpdate />} />
      <Route path="delete" element={<ProcedureMedicineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProcedureMedicineRoutes;
